import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Event } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { switchMap } from 'rxjs/operators';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '../../api/api-partner.service';
import swal from 'sweetalert/dist/sweetalert.min.js';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-productvoucherbatchdetail',
  templateUrl: './productvoucherbatchdetail.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductvoucherbatchdetailComponent implements OnInit {
  @ViewChild('closeBtn', { static: false }) closeBtn: ElementRef;
  @ViewChild('openModall', { static: false }) openModall: ElementRef;
   @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  @ViewChild("fileReupload", { static: false })
  fileReupload: ElementRef;
  @ViewChild("target", { static: false })
  target: ElementRef;


  ProductList: any = [];
  subProductList: any = [];
  Producttype: any = [];
  detailbatch: any = [];
  listdraft: any = [];
  loaddraft = false;
  isvalid = false;

  Billing: any = [];
  Productsource: any = [];
  Provisioning: any = [];
  dataupdate: any = [];
  arraychannel: any = [];
  response: any = {};
  paging : any = {};
  itemdihapus: any = {};
  pcodeold: any = {};


  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
	  private router: Router,
    public LoadJs: LoadJsService,
    public LoadJsOrder: LoadJsService,
	  public partnerService: ApiPartnerService
  ) { }
  formProv = this.fb.group({
    provisioningid : [''],
  })

  formOrderUpload = this.fb.group({
    value_upload: [''],
    id: [''],
    subject: [''],
    description: [''],

  })

  formOrderReupload = this.fb.group({
    value_upload: [''],
    id: ['']
  })

  formOrder = this.fb.group({
    id: [''],
    productname: [''],
    productcode: [''],
    billingtype: [''],
    producttype: [''],
    startdate: [''],
    enddate: [''],
    price: [''],
    age: [''],
    productsource: [''],
    provisioningid: [''],
    provisioningcode: [''],
    productchannels: [''],
    subproducts: [''],
    productcategory: [''],
  })
  formChannel = this.fb.group({
    temp_data : [''],
    id : [''],
    provisioningcode: [''],
    id_content: [''],
    channel_name: [''],
    position: [''],
  })

  selectedChannel: any = []
  data_table_channel: any = []
  listchannel:any={}
  channeldata:any={}
  sourceValue:any={}
  productcategory : any = {};
  subproducttype : number;
  subrowProducttype : any = [];
  subproductselected : any = [];


  btn_save = true
  btn_save_disable = false
  btn_loading = false
  loading_create = false
  alert_failed = false
  alert_success = false
  buttonUpdate = false
  buttonSave = true
  hidId = false

  isNew = false;
  table_load = false
  pcodeavail = false
  pcodenotavail = false
  dupl = false
  statusx:boolean = false
  checkx = false

  msearch : string;
  msubsearch : string;
  searchtype : string;
  producttype : string;
  provisioningcode : string;
  
  meta = [];
  self = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';

  alert_act='';
  id : number;
  batchid : number;

  ngOnInit() {
    this.route.params.subscribe(params => {
       this.id = params['id']; // (+) converts string 'id' to a number

      
       this.batchid = params['batchid']; // (+) converts string 'id' to a number
      // load detail batch
      this.loaddraft = false;
      this.loadBatchdetail(this.batchid);
    });

    
       
    //this.loadStart();
  }
  
  loadStart() {
    
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if ((params.search != '' || params.productcode != '' || params.provisioningcode != '' || params.searchtype != '' ) && params.search != undefined ){
         this.msearch = params.search; 
         this.searchtype = params.searchtype; 
         this.producttype = params.producttype; 
         this.provisioningcode = params.provisioningcode; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadProduct(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadProduct(this.queryParams);
        }
      });
    this.LoadJs.loadScriptOrderService()
    //this.loadBilling()
    //this.loadProducttype()
    //this.loadProductsource()
    //this.loadProvisioning()
  }

  refreshPage() {
    
    this.msearch = undefined
    this.searchtype = undefined
    this.producttype = undefined
    this.provisioningcode = undefined

    this.ngOnInit();
  }
  resetForm(){
    this.formChannel.reset()
  }
  clearForm() {
    this.sourceValue = ''
    this.formOrder.reset()
    this.data_table_channel = []
    this.resetForm()
    this.formOrder.get('billingtype').setValue(undefined)
    this.formOrder.get('producttype').setValue(undefined)
  }
  remove(item:any) {
    this.data_table_channel.splice(item, 1);
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  check1(){
    this.statusx = !this.statusx
    if (this.statusx == false){
      // console.log("hh")
      this.formChannel.reset()
      this.data_table_channel = []
    }
  }
  
  search()
  {
    if ( this.msearch == undefined){
      this.msearch = '';
    }

    this.querySearch = true;

    if ( this.producttype == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch;
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&producttype='+this.producttype;
    }
    
    if ( this.provisioningcode != undefined ){
      this.searchQueryParams += '&provisioningcode='+this.provisioningcode;
    }
    
    if ( this.searchtype != undefined ){
      this.searchQueryParams += '&searchtype='+this.searchtype;
    }

    this.loadProduct(this.searchQueryParams);
  }

  searchsub()
  {
    if ( this.msubsearch == undefined){
      this.msubsearch = '';
    }
    
    this.querySearch = true;

    if ( this.subproducttype == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msubsearch;
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msubsearch+'&producttype='+this.subproducttype;
    }
    
    if ( this.provisioningcode != undefined ){
      this.searchQueryParams += '&provisioningcode='+this.provisioningcode;
    }
    
    this.loadProductsub(this.searchQueryParams);
  }

  checkch(item:any){
    console.log("as")
    this.data_table_channel.forEach(row => {
      if(item.channel_name == row.channel_name){
        console.log('true',item.channel_name, row.channel_name)
        this.dupl = true
      // }else{
      }
      
      if(item.channel_name != row.channel_name){
        console.log('false')
        this.dupl = false
      }
    })
  }
  checkpcode(){
    const data = this.formOrder.get('productcode').value

    if( data != this.pcodeold){

      return this.partnerService.PostCheckpcode(data).subscribe((output: any) => {
        console.log(output.data);
  
        if(output.status){
          this.pcodenotavail = false
          this.pcodeavail = true
        }else{
          this.pcodeavail = false
          this.pcodenotavail = true
        }
      })
      
    }else{
      this.pcodeavail = false
      this.pcodenotavail = false
    }

  }

  public opnnModallX() {
    setTimeout(()=>{
      this.opnnModal()
    }, 100);
  }
  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }
  private opnnModal(): void {
    this.openModall.nativeElement.click();
  }
  alertsx(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(()=>{
      this.closeModal()
      this.ngOnInit()
    }, 1000);
  }
  alertfx(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
    
  }

  unun(){
    console.log(this.formOrder.value)
  }
  onActionClick(act:any, item: any)
  {
    // console.log(item);
    this.pcodeavail = false
    this.pcodenotavail = false
    this.statusx = false
    this.checkx = false
    this.alert_act = act;

    if ( act == "create") {
      this.statusx = false
      this.clearForm();

      this.pcodeold = ''
    }
    if ( act == "update") {
      this.statusx = false
      this.onUpdate(item)
      // console.log(item)

      this.pcodeold = item.productcode
    }
    if ( act == "hapus") {
      this.itemdihapus = item
      console.log(item)
    }
  }

  onUpdate(item: any)
  {
    // this.isNew = false;
    // this.buttonUpdate = true;
    // this.buttonSave = false;
    // this.formOrder.get('productchannels').setValue('')
    this.subproductselected = [];
    this.subProductList = [];
    return this.partnerService.GetProductsale(item.id).subscribe((output: any) => {
      // this.formOrder = output.data;
      this.dataupdate = output.data
      console.log(output);

      this.formOrder.get('id').setValue(this.dataupdate.id);
      this.formOrder.get('productname').setValue(this.dataupdate.productname);
      this.formOrder.get('productcode').setValue(this.dataupdate.productcode);
      this.formOrder.get('producttype').setValue(this.dataupdate.producttype);
      this.formOrder.get('billingtype').setValue(this.dataupdate.billingtype);
      this.formOrder.get('startdate').setValue(this.dataupdate.startdate);
      this.formOrder.get('enddate').setValue(this.dataupdate.enddate);
      this.formOrder.get('price').setValue(this.dataupdate.price);
      this.formOrder.get('age').setValue(this.dataupdate.age);
      this.formOrder.get('productsource').setValue(this.dataupdate.productsource);
      this.formOrder.get('provisioningcode').setValue(this.dataupdate.provisioningcode);
      this.formOrder.get('productcategory').setValue(this.dataupdate.productcategoryid);
      this.productcategory = this.dataupdate.productcategoryid;
      
      for (let value of this.dataupdate.productbundlingitem) {
        this.picksubproduct(value.service);
      }
      
      this.data_table_channel = this.dataupdate.productchannel
      // this.data_table_channel.push(
      //   {
      //     'position':this.data_table_channel.length+1,
      //     'id':this.arraychannel.id,
      //     'channel_name':this.arraychannel.channel_name,
      //     'provisioningcode':this.arraychannel.provisioningcode,
      //     'id_content':this.arraychannel.id_content,
      //     'id_content_core':this.arraychannel.id_content_core,
      //     'id_package':this.arraychannel.id_package,
      //   }
      // )
      // console.log(this.arraychannel)
      this.loadUpdatechannel()
      // console.log(this.data_table_channel)

    })
  }

  onDelete(item: any, el: HTMLElement)
  {

    console.log(item)
    return this.partnerService.SetDeleteproductsale(item.id).subscribe((output: any) => {
      this.ngOnInit()

      console.log(output.data);
      this.alert_success = true
      setTimeout(()=>{
        el.scrollIntoView({behavior:"smooth"})
      }, 500);
      setTimeout(()=>{
        this.alert_success = false
      }, 6000);
    })
  }

  submitDelete() {
    let item = this.dataupdate
    console.log(item)
    swal({
      title: "Are you sure?",
      text: '"'+item.productname+'" akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        console.log(item)
        this.partnerService.SetDeleteproductsale(item.id)
          .subscribe((output: any) => { 
            if (output.status == true) {
              this.alertsx('"'+item.productname+'" berhasil dihapus')
            } else {
              this.alertfx('"'+item.productname+'" gagal dihapus')
            }
        })
        
      }
    });
    
  }

  submitSave(el: HTMLElement) {

    this.formOrder.get('productchannels').setValue(this.data_table_channel)
    this.formOrder.get('provisioningid').setValue(this.sourceValue.id)
    this.formOrder.get('provisioningcode').setValue(this.sourceValue.provisioningcode)

    this.formOrder.get('productcategory').setValue(this.productcategory) 
    this.formOrder.get('subproducts').setValue(this.subproductselected) 


    // this.btn_save = false
    // this.loading_create = true
    // this.btn_save_disable = true
    // this.btn_loading = true
    console.log(this.formOrder.value)
    this.partnerService.PostCreateproduct(this.formOrder.value).subscribe((output: any) => { 
        // console.log(output)
        if (output.status == true) {
          this.response = output.data
          this.alertsx(output.message)
          
          // this.btn_save = true
          // this.btn_save_disable = false
          // this.loading_create = false
          // this.ngOnInit()
          // this.LoadJs.loadScriptProductStb()
          // this.alert_success = true
        
          // setTimeout(()=>{
          //   el.scrollIntoView({behavior:"smooth"})
          // }, 500);
          // setTimeout(()=>{
          //   this.alert_success = false
          // }, 6000);

        } else {
          
          this.alertfx(output.message)
        //   this.btn_save = true
        //   this.btn_save_disable = false
        //   this.loading_create = false
        //   this.LoadJs.loadScriptProductStb()
        //   this.alert_failed = true
        
        //   setTimeout(()=>{
        //     el.scrollIntoView({behavior:"smooth"})
        //   }, 500);
        //   setTimeout(()=>{
        //     this.alert_failed = false
        //   }, 6000);
        }
      }
    );
  }

  submitUpdate(el: HTMLElement) {

    this.formOrder.get('productchannels').setValue(this.data_table_channel)
    this.formOrder.get('productcategory').setValue(this.productcategory) 
    this.formOrder.get('subproducts').setValue(this.subproductselected) 
    
    this.btn_save = false
    this.loading_create = true
    this.btn_save_disable = true
    this.btn_loading = true
    // console.log(this.formOrder.value)
    this.partnerService.SetUpdateproductsale(this.formOrder.value)
      .subscribe((output: any) => { 
        // console.log(this.response)
        
        if (output.status == true) { 
          this.response = output.data
          this.alertsx(output.message)

          // this.btn_save = true
          // this.btn_save_disable = false
          // this.loading_create = false
          // this.ngOnInit()
          // this.LoadJs.loadScriptProductStb()
          // this.alert_success = true
          
          // setTimeout(()=>{
          //     el.scrollIntoView({behavior:"smooth"})
          //   }, 500);
          //   setTimeout(()=>{
          //     this.alert_success = false
          //   }, 6000);
        } else {
          
          this.alertfx(output.message)
        //   this.btn_save = true
        //   this.btn_save_disable = false
        //   this.loading_create = false
        //   this.LoadJs.loadScriptProductStb()
        //   this.alert_failed = true
        //   setTimeout(()=>{
        //     el.scrollIntoView({behavior:"smooth"})
        //   }, 500);
        //   setTimeout(()=>{
        //     this.alert_failed = false
        //   }, 6000);
        }
      
      }
    );
  }


  loadBatchdetail(id) {
    return this.partnerService.GetBatchuploadvoucer(id).subscribe((output: any) => {
      //this.Producttype = output.data;
      this.detailbatch = output.data;
      this.loadListdraft(id);
      console.log(output);

    })
  }

  loadListdraft(id) {
    this.loaddraft = false;
    return this.partnerService.GetListdraftvoucer(id).subscribe((output: any) => {
      //this.Producttype = output.data;
      this.listdraft = output.data;
      this.loaddraft = true;
      this.isvalid = output.isvalid;

      console.log(this.listdraft);

    })
  }

  removelistdraft(item)
  {
    if ( confirm('Yakin untuk hapus ?')){
      return this.partnerService.Postdeletedraft(item.id).subscribe((output: any) => {
        this.loadListdraft(this.batchid);

      })
    }
  }


  loadBilling() {
    return this.partnerService.GetBillingtype().subscribe((output: any) => {
      this.Billing = output.data;
    })
  }
  loadProducttype() {
    this.subrowProducttype = [];
    return this.partnerService.GetProducttype().subscribe((output: any) => {
      this.Producttype = output.data;
      this.subrowProducttype.push(output.data[2]);
      this.subrowProducttype.push(output.data[3]);
    })
  }
  loadProductsource() {
    return this.partnerService.GetProductsource().subscribe((output: any) => {
      this.Productsource = output.data;
    })
  }
  loadProvisioning() {
    console.log(this.formOrder.value.productsource);
   
    return this.partnerService.GetSourceProvisioning('?productsource='+this.formOrder.value.productsource).subscribe((output: any) => {
      this.Provisioning = output.data;
    })
  }
  loadChannel() {
    this.resetForm()
    this.selectedChannel = []
    this.data_table_channel = []
    // this.formProv.get('provisioningid').setValue(e.target.value);
    // console.log(e.target.value)
    let data = { "provisioningid": this.sourceValue.id }
    this.partnerService.Getprovisioningchannel(data).subscribe((output: any) => { 
    // this.partnerService.Getprovisioningchannel(this.formProv.value).subscribe((output: any) => { 
        this.listchannel = output
        console.log(this.listchannel)
        for (let i = 0; i < this.listchannel.data.length; i++) {
          // console.log(this.listchannel.data[i].id);
          this.selectedChannel.push(
            {
              'id':this.listchannel.data[i].id,
              'provisioningcode':this.listchannel.data[i].provisioningcode,
              'channel_name':this.listchannel.data[i].channel_name,
              'id_content':this.listchannel.data[i].id_content,
              'id_content_core':this.listchannel.data[i].id_content_core,
              'id_package':this.listchannel.data[i].id_package,
            }
          )
        }
        console.log(this.selectedChannel)
      });  
  }
  loadUpdatechannel() {
    this.resetForm()
    this.selectedChannel = []
    // this.formProv.get('provisioningid').setValue(e.target.value);
    // console.log(e.target.value)
    let data = { "provisioningid": this.formOrder.get('provisioningcode').value }
    this.partnerService.Getprovisioningchannel(data).subscribe((output: any) => { 
    // this.partnerService.Getprovisioningchannel(this.formProv.value).subscribe((output: any) => { 
        this.listchannel = output
        // console.log(this.listchannel)
        for (let i = 0; i < this.listchannel.data.length; i++) {
          // console.log(this.listchannel.data[i].id);
          this.selectedChannel.push(
            {
              'id':this.listchannel.data[i].id,
              'provisioningcode':this.listchannel.data[i].provisioningcode,
              'channel_name':this.listchannel.data[i].channel_name,
              'id_content':this.listchannel.data[i].id_content,
              'id_content_core':this.listchannel.data[i].id_content_core,
              'id_package':this.listchannel.data[i].id_package,
            }
          )
        }
        // console.log(this.selectedChannel)
      });  
  }

  loadProduct(params: any) {
    this.table_load = true;
    return this.partnerService.GetProduct(params).subscribe((output: any) => {
    console.log(output);
      this.ProductList = output.data;

      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;
    })
  }

  loadProductsub(params: any) {
    this.table_load = true;
    return this.partnerService.GetProduct(params).subscribe((output: any) => {
    console.log(output);
      this.subProductList = output.data;

    })
  }

  setPosition() {
    this.data_table_channel.push(
      {
        'position':this.data_table_channel.length+1,
        'id':this.channeldata.id,
        'channel_name':this.channeldata.channel_name,
        'provisioningcode':this.channeldata.provisioningcode,
        'id_content':this.channeldata.id_content,
        'id_content_core':this.channeldata.id_content_core,
        'id_package':this.channeldata.id_package,
      }
    )
    this.resetForm()
    // console.log(this.data_table_channel, this.channeldata, 'masuk')
    // console.log(this.channeldata)
    
  }

  pickproductcategory()
  {
    //console.log(this.productcategory);
    //alert('aha');
    // load productaddon
  }

  picksubproduct(subitem)
  {

    //alert(subitem.provisioningname);
    if ( this.sourceValue.provisioningcode != undefined){
      //alert(this.sourceValue.provisioningcode);
    }

    if (  subitem.provisioningname != this.sourceValue.provisioningcode) {
      if ( this.subproductselected.findIndex(obj => obj.id == subitem.id) == -1 ) {
        this.subproductselected.push(subitem);
        console.log(this.subproductselected);
      }
    }

  }

  removesubproduct(i)
  {
    this.subproductselected.splice(i,1);
  }

  submit(){
    if ( confirm('Yakin Submit ? ')) {
      this.partnerService.PostSubmitBatchVoucher({'id':this.batchid})
        .subscribe((output: any) => {
          console.log(output);    
          this.loadListdraft(this.batchid);   
        }
      );
    }
  }

  processFile(event : any) {
    // console.log('masuk')
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {
          type: 'binary',cellDates:true}
          );
      /* first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      console.log(XLSX.utils.sheet_to_json(ws, {header:0}));
      this.formOrderUpload.get('value_upload').setValue(XLSX.utils.sheet_to_json(ws, {header:0}));
      this.formOrderReupload.get('value_upload').setValue(XLSX.utils.sheet_to_json(ws, {header:0}));
      // console.log(this.formValidasiOrder.value)
      
    };
    reader.readAsBinaryString(target.files[0]);
  }

  submitSaveUploaddraft(id: any, el: HTMLElement) {
    // this.alert_failed = false
    // this.alert_success = false
    // console.log(this.formOrder.value)

    this.formOrderUpload.get('id').setValue(id);
    
    console.log(id,this.formOrderUpload.value);

    this.partnerService.PostReUploadVoucher(id, this.formOrderUpload.value)
      .subscribe((output: any) => {
        console.log(output);    
        this.loadListdraft(this.batchid);   
      }
    );
  }

}
